import { render } from "./FooterSection.vue?vue&type=template&id=b36bcd6c&scoped=true"
const script = {}

import "./FooterSection.vue?vue&type=style&index=0&id=b36bcd6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36bcd6c"]])

export default __exports__